import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { UploadDataService } from 'src/app/services/uploadData.service';
import { MyListingsService } from '../../services/my-listings.service';
import { LocalStorageService } from '../../services/local-storage.service';
import { environment } from '../../../environments/environment';
import { HeaderComponent } from '../header/header.component';
import { ToastService, ToastType } from '../../services/toast.service';
import { Subject, catchError, concatMap, from, groupBy, map, mergeMap, of, takeUntil } from 'rxjs';
import { AppState } from 'src/app/app.state';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { v4 as uuidv4 } from 'uuid';
import { StepperSaveComponent } from '../stepper-save/stepper-save.component';
import { MatDialog } from '@angular/material/dialog';
import heic2any from 'heic2any';

@Component({
  selector: 'app-photos',
  templateUrl: './photos.component.html',
  styleUrls: ['./photos.component.css'],
})
export class PhotosComponent {

  @ViewChild(HeaderComponent) header: HeaderComponent;
  @ViewChild(StepperSaveComponent) stepperSaveComponent!: StepperSaveComponent;
  @ViewChild('confirmationDialog', { static: true }) confirmationDialog: any;

  files: File[] = [];
  filesSelected?: FileList;
  message: string[] = [];
  urlsList: string[] = [];
  extList: string[] = [];

  alreadyUploadedImages: any[] = [];
  isButtonLoader: boolean = false;
  singleFormSubmit: boolean = true;
  onDestroyNotifier$ = new Subject();
  photographyRelease: boolean = false;
  submitted: boolean = false;
  touched: boolean = false;
  isUploading: boolean = false;
  hidePlanSelection: boolean = false;
  historyState: any;
  photosData: {};
  myListingId: string;
  dialogRef: any;
  closeFlag: string;
  saveFlag: string;


  constructor(
    private router: Router,
    private uploadService: UploadDataService,
    public myListingsService: MyListingsService,
    public localStorageService: LocalStorageService,
    public toastService: ToastService,
    public appState: AppState,
    private cdr: ChangeDetectorRef,
    private dialog: MatDialog,
  ) { };


  ngOnInit(): void {
    this.appState.companyInfo$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((res) => {
      if (res) {
        this.hidePlanSelection = res?.sellSideConfig?.hidePlanSelection || false;

        if (res?.sellSideConfig && res?.sellSideConfig?.singleFormSubmit) {
          this.singleFormSubmit = true;
        } else {
          this.singleFormSubmit = false;
        }
      }
      this.cdr.detectChanges();
    });

    this.historyState = history.state;

    if (!this.historyState.address) {
      this.router.navigateByUrl('/my-listing');
      return;
    }
    this.myListingId = this.historyState.myListingId ? this.historyState.myListingId : this.localStorageService.get('myListingId') ? this.localStorageService.get('myListingId') : null;

    if (this.historyState.photosData) {
      let lImageIds = this.historyState.photosData.ImageIds;
      this.photographyRelease = this.historyState.photosData.photographyRelease;
      for (let index = 0; index < lImageIds.length; index++) {
        const element = lImageIds[index];
        this.alreadyUploadedImages.push({
          url: environment.prospektr_sell_media_url + element,
          ImageID: element,
          uniqueId: uuidv4()
        });
      }
    }
  }

  changePhotographyRelease() {
    this.photographyRelease = !this.photographyRelease;
    this.touched = true;
  }

  async onDrop(event: DragEvent): Promise<void> {
    event.preventDefault();
    event.stopPropagation();

    this.filesSelected = event.dataTransfer.files;
    this.manageFileUpload();
  }

  async selectFiles(event: any): Promise<void> {
    this.filesSelected = event.target.files;
    this.manageFileUpload();
  }

  async manageFileUpload() {
    this.touched = true;
    this.message = [];
    let isHeicImagesUploaded = false;
    let selectedImagesCount = 0;
    let alreadyUploadedImagesCount = this.alreadyUploadedImages.length;

    if (this.filesSelected && this.filesSelected[0]) {
      for (let i = 0; i < this.filesSelected.length; i++) {
        const file = this.filesSelected[i];
        const reader = new FileReader();
        let extension = file.type ? file.type.replace('image/', '').toLowerCase() : null;

        if (!extension) {
          const fileName = file.name;
          const fileExtensionMatch = fileName.match(/\.([a-zA-Z0-9]+)$/);
          if (fileExtensionMatch) {
            extension = fileExtensionMatch[1].toLowerCase();
          }
        }

        if (['jpeg', 'jpg', 'heic', 'png'].includes(extension)) {
          selectedImagesCount = selectedImagesCount + 1;
          if (extension === 'heic') {
            isHeicImagesUploaded = true;
            this.isUploading = true;
            const heic2any = await import('heic2any');
            heic2any.default({ blob: file, toType: 'image/jpeg' })
              .then((convertedBlob: Blob) => {
                const convertedReader = new FileReader();
                convertedReader.onload = (e: any) => {
                  const preview = {
                    url: e.target.result,
                    ext: 'jpg',
                    project: "PROSPECTOR",
                    env: "DEV",
                    type: "base64",
                    uniqueId: uuidv4(),
                    loading: true
                  };
                  this.alreadyUploadedImages.push(preview);
                  if ((this.alreadyUploadedImages.length - alreadyUploadedImagesCount) === selectedImagesCount) {
                    setTimeout(() => {
                      this.manageUpload();
                    }, 500);
                  }
                };
                convertedReader.readAsDataURL(convertedBlob);
              })
              .catch((error: any) => {
                console.error('Conversion failed:', error);
              });
          } else {
            reader.onload = (e: any) => {
              const preview = {
                url: e.target.result,
                ext: extension,
                project: "PROSPECTOR",
                env: "DEV",
                type: "base64",
                uniqueId: uuidv4(),
                loading: true
              };
              this.alreadyUploadedImages.push(preview);
              if ((this.alreadyUploadedImages.length - alreadyUploadedImagesCount) === selectedImagesCount && !isHeicImagesUploaded) {
                setTimeout(() => {
                  this.manageUpload();
                }, 500);
              }
            };
            reader.readAsDataURL(file);
          }
        } else {
          if (i === this.filesSelected.length - 1) {
            this.manageUpload();
          }
          this.toastService.toast('You can upload only JPEG, JPG, PNG, HEIC file format', ToastType.Warning);
        }
      }
    }
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
  }

  drop(event: CdkDragDrop<string[]>): void {
    this.touched = true;
    if (event.previousContainer === event.container) {
      // Move the item within the same container
      moveItemInArray(this.alreadyUploadedImages, event.previousIndex, event.currentIndex);
    } else {
      // Transfer the item from one container to another
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    }
  }

  switchTab(event) {
    if (event == 0) {
      if (this.isUploading) {
        this.toastService.toast('Photos uploading in progress', ToastType.Warning);
      } else if (this.touched) {
        this.closeFlag = 'close&switch';
        this.saveFlag = 'save&switch';

        this.stepperSaveComponent.updateSelectedTab('Photos');
        this.dialogRef = this.dialog.open(this.confirmationDialog);
        this.cdr.detectChanges();
      } else {
        this.router.navigateByUrl('/home-details', {
          state: this.historyState
        });
      }
    }
  }

  closeDialog(flag) {
    this.dialogRef.close();
    if (flag == 'close&continue') {
      this.router.navigateByUrl('/my-listing', {
        state: this.historyState
      });
    } else if (flag == 'close&switch') {
      this.router.navigateByUrl('/home-details', {
        state: this.historyState
      });
    }
  }

  close() {
    if (this.touched) {
      this.closeFlag = 'close&continue';
      this.saveFlag = 'save&close';

      this.dialogRef = this.dialog.open(this.confirmationDialog);
    } else {
      this.router.navigateByUrl('/my-listing', {
        state: this.historyState
      });
    }
  }

  back() {
    this.router.navigateByUrl('/listing-details', {
      state: this.historyState
    });
  }

  backToHome() {
    this.router.navigateByUrl('/home-details', {
      state: this.historyState
    });
  }

  deleteImages(i) {
    this.touched = true;
    this.alreadyUploadedImages.splice(i, 1);
    this.cdr.detectChanges();
  }

  saveImages(flag) {
    if (flag == 'skip') {
      this.router.navigateByUrl('/my-listing', {
        state: this.historyState
      });
    } else {
      this.submitted = true;
      this.dialogRef?.close();

      if (this.alreadyUploadedImages.length > 0) {
        if (this.photographyRelease) {
          this.isButtonLoader = true;
          let lImageIds = [];
          this.alreadyUploadedImages.forEach(element => {
            lImageIds.push(element.ImageID);
          });
          this.updateMyListings(lImageIds, flag);
        } else {
          this.toastService.toast('Please Confirm Photography Release', ToastType.Warning);
        }
      } else {
        this.toastService.toast('No images upload to save', ToastType.Warning);
      }
    }
  }

  savePhotos(submit) {
    if (this.historyState.photosData && this.historyState.photosData.ImageIds) {
      this.updateMyListings([], submit);
    } else {
      this.skip(null);
    }
  }


  manageUpload() {
    console.log('Starting upload process');
    if (!this.alreadyUploadedImages || this.alreadyUploadedImages.length === 0) {
      console.log('All images already uploaded');
      return;
    }

    console.log('Total Images:', this.alreadyUploadedImages.length);

    let imagesToUpload = this.alreadyUploadedImages.filter(element => !element.ImageID);

    if (!imagesToUpload || imagesToUpload.length === 0) {
      console.log('No images to upload');
      return;
    }

    console.log('Images to upload:', imagesToUpload.length);
    this.isUploading = true;

    from(imagesToUpload).pipe(
      mergeMap(
        element => this.uploadFile(element),
        5 // Concurrency limit
      )
    ).subscribe({
      next: (res) => {
        console.log("Upload completed", res);
      },
      error: (err: any) => {
        this.isUploading = false;
        console.error("Error in uploads", err);
      },
      complete: () => {
        this.isUploading = false;
        console.log('All uploads complete');
      }
    });
  }

  // Function to handle the file upload
  uploadFile(preview: any) {
    console.log('Starting upload for', preview);
    return this.uploadService.uploadData(preview).pipe(
      map(res => {
        console.log("uploadFile response: ", res);
        if (res && res.status === 200 && res.uniqueId) {
          this.alreadyUploadedImages.forEach(element => {
            if (element.uniqueId === res.uniqueId) {
              let path = null;
              if (res.ImageID != null) {
                path = res.ImageID;
              } else if (res.Key) {
                path = res.Key.replace(/^PROSPECTOR\//, '');
              }

              element['url'] = environment.prospektr_sell_media_url + path;
              element['ImageID'] = path;
              element.loading = false;
              console.log('Updated element with new URL and ImageID:', element);
            }
          });
        } else {
          this.alreadyUploadedImages.forEach(element => {
            if (element.uniqueId === preview.uniqueId) {
              element.loading = false;
              console.log('Marked element as not loading due to upload failure:', element);
            }
          });
          console.log('Image Upload Failed');
        }
        return res;
      }),
      catchError(err => {
        this.alreadyUploadedImages.forEach(element => {
          if (element.uniqueId === preview.uniqueId) {
            element.loading = false;
          }
        });
        console.error('uploaded err:', err);
        throw err;
      })
    );
  }


  updateMyListings(lImageIds, submit) {

    this.photosData = {};

    if (submit == null || submit == 'skip' || submit == 'save' || submit == 'save&wait' || submit == 'save&close' || submit == 'save&switch') {
      if (!this.historyState.completedIndex || this.historyState['completedIndex'] < 1.7) {
        this.photosData["stage"] = 1.7;
      }

      if (this.historyState.stageName) {
        if (this.historyState.stageName.split(',').indexOf('Photos') <= -1) {
          this.photosData["stageName"] = "Photos" + "," + this.historyState.stageName;
        }
      } else {
        this.photosData["stageName"] = "Photos" + "," + "Home Details";
      }
    }

    if (this.historyState?.isPaymentDone) {
      this.photosData["updateListing"] = true;
    }

    let lImageIdsFiltered = [];
    lImageIdsFiltered = lImageIds.filter(image => image !== null && image != undefined);

    this.photosData["ImageIds"] = lImageIdsFiltered;
    if (lImageIdsFiltered && lImageIdsFiltered.length > 0) {
      this.photosData["PhotoUpdateTime"] = new Date();
    }

    this.photosData["photographyRelease"] = this.photographyRelease;
    this.photosData["updatedDate"] = new Date();

    this.photosData = this.filterInputJson(this.photosData);

    this.myListingsService.UpdateListing(this.myListingId, this.photosData).subscribe(
      {
        next: (res) => {
          this.touched = false;
          if (submit == 'save&wait') {
            if (!this.historyState.completedIndex || this.historyState['completedIndex'] < 1.7) {
              this.historyState['completedIndex'] = 1.7;
            }
            this.historyState['photosData'] = this.photosData;
            this.historyState.stageName = this.photosData["stageName"];
            this.isButtonLoader = false;
            this.toastService.toast('Photos uploaded successfully!!!', ToastType.Information);
          } else {
            this.routeToNextPage(this.photosData, submit);
          }
        },
        error: (err) => {
          if (submit == 'save&wait') {
            if (!this.historyState.completedIndex || this.historyState['completedIndex'] < 1.7) {
              this.historyState['completedIndex'] = 1.7;
            }
            this.historyState.stageName = this.photosData["stageName"];
            this.isButtonLoader = false;
            this.toastService.toast('Photos upload failed!!!', ToastType.Error);
          } else {
            this.routeToNextPage(null, submit);
          }
          console.log(err);
        }
      }
    );

  }

  routeToNextPage(photosData, submit) {

    if (!this.historyState.completedIndex || this.historyState['completedIndex'] < 1.7) {
      this.historyState['completedIndex'] = 1.7;
    }
    this.historyState['photosData'] = photosData;
    this.historyState.stageName = this.photosData["stageName"];

    if (submit == 'save&close') {
      this.isButtonLoader = false;
      this.router.navigateByUrl('/my-listing', {
        state: this.historyState
      });
    } else if (submit == 'save&switch') {
      this.isButtonLoader = false;
      this.router.navigateByUrl('/home-details', {
        state: this.historyState
      });
    } else {
      this.isButtonLoader = false;
      if (this.singleFormSubmit) {
        this.router.navigateByUrl('/my-listing', {
          state: this.historyState
        });
      } else {
        this.router.navigateByUrl('/plans', {
          state: this.historyState
        });
      }
    }
  }

  skip(skip) {
    this.historyState['completedIndex'] = 1.7;
    this.router.navigateByUrl('/plans', {
      state: this.historyState
    });
  }

  filterInputJson(obj) {
    Object.keys(obj).forEach(key => {
      if (obj[key] == null) {
        delete obj[key];
      }
    });
    return obj;
  }
}
